import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { parseContentForEditing } from '../../../utils/richText';

interface RichTextEditorProps {
  value?: string;
  onChange?: (htmlContent: string, jsonContent: any) => void;
  placeholder?: string;
  height?: number;
  disabled?: boolean;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value = '',
  onChange,
  placeholder = 'Enter content...',
  height = 200,
  disabled = false,
}) => {
  const [editorContent, setEditorContent] = useState<string>('');
  const [contentJson, setContentJson] = useState<any>(null);

  // Initialize editor content when value prop changes
  useEffect(() => {
    if (value !== editorContent) {
      const { parsedContent, jsonContent } = parseContentForEditing(value);
      setEditorContent(parsedContent);
      setContentJson(jsonContent);
    }
  }, [value]);

  const handleChange = (content: string, delta: any, source: string, editor: any) => {
    if (source === 'user') {
      setEditorContent(content);
      
      // Get Quill Delta JSON
      const quillDelta = editor.getContents();
      setContentJson(quillDelta);
      
      // Notify parent component
      if (onChange) {
        onChange(content, quillDelta);
      }
    }
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent', 'align', 'link'
  ];

  return (
    <div style={{ height: height + 'px' }}>
      <ReactQuill
        theme="snow"
        value={editorContent}
        onChange={handleChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        readOnly={disabled}
        style={{ height: height - 42 + 'px' }} // Account for toolbar height
      />
    </div>
  );
};

export default RichTextEditor;
